import { useContext, useState } from "react";
import { MediaContext } from "../../context/MediaContext";
import { SocketContext } from "../../context/SocketContext";
import { AuthContext } from "../../context/AuthContext";
import { SFeedbackBar, SReaction } from "./FeedbackBar.styles";
import ReactTooltip from "react-tooltip";
import { Button } from "react-bootstrap";

const FeedbackBar = ({ isSidePanelVisible, duration }) => {
  const { player } = useContext(MediaContext);
  const { asyncUnderstandings, chatMessages, bookmarks, sendSocketEvent } = useContext(SocketContext);
  const { currentUser } = useContext(AuthContext);

  const [bookmarkTooltip, showBookmarkTooltip] = useState(false);
  const [reactionTooltip, showReactionTooltip] = useState(false);

  const getReactionStyle = (value) => {
    let face = "fas fa-smile",
      color = "rgba(75, 192, 192, 0.7)",
      type = "success";
    if (value === 1) {
      face = "fas fa-dizzy";
      color = "rgba(255, 99, 132, 0.7)";
      type = "error";
    }
    if (value === 2) {
      face = "fas fa-meh";
      color = "rgba(255, 205, 86, 0.7)";
      type = "warning";
    }

    return { icon: face, color, type };
  };

  const getPercentage = (videoTs) => {
    return `${(videoTs / duration) * 100}%`;
  };

  const setBookmarksTooltipContent = (dataTip) => {
    if (dataTip) {
      const bookmark = JSON.parse(dataTip);

      const onBookmarkDelete = () => {
        sendSocketEvent("bookmarks/deleteBookmark", { uuid: bookmark.uuid });
        showBookmarkTooltip(false);
      };

      return (
        <div className="d-flex flex-row justify-content-between align-items-center">
          <span className="fs-5 me-2">{bookmark.name}</span>
          {currentUser.email === bookmark.user.email && (
            <Button variant="danger" onClick={onBookmarkDelete}>
              <i className="fas fa-times" />
            </Button>
          )}
        </div>
      );
    }
  };

  const setReactionTooltipContent = (dataTip) => {
    if (dataTip) {
      const reaction = JSON.parse(dataTip);

      const onReactionDelete = () => {
        sendSocketEvent("feedback/deleteReaction", { uuid: reaction.uuid });
        showReactionTooltip(false);
      };

      return (
        <div className="d-flex flex-row justify-content-between align-items-center">
          {currentUser.email === reaction.email && (
            <Button variant="danger" onClick={onReactionDelete}>
              <i className="fas fa-times" />
            </Button>
          )}
        </div>
      );
    }
  };

  return (
    <>
      {player && (
        <SFeedbackBar sidePanelVisible={isSidePanelVisible}>
          {/* Reactions */}
          {asyncUnderstandings
            .filter((u) => u.email === currentUser.email)
            .map((u) => {
              const style = getReactionStyle(u.value);

              return (
                <SReaction
                  key={u.uuid}
                  className={`${style.icon} fs-1`}
                  left={getPercentage(u.videoTs)}
                  color={style.color}
                  onClick={() => player?.seekTo(u.videoTs)}
                  onMouseEnter={() => showReactionTooltip(true)}
                  data-for="reactions-tooltip"
                  data-tip={JSON.stringify(u)}
                  data-type={style.type}
                />
              );
            })}

          {/* Questions */}
          {Object.values(chatMessages)
            .filter((m) => m.isQuestion)
            .map((q, index) => (
              <SReaction
                key={index}
                className="fas fa-question fs-1"
                left={getPercentage(q.videoTs)}
                color="#5AC0D6"
                onClick={() => player?.seekTo(q.videoTs)}
                data-for="questions-tooltip"
                data-tip={q.text}
                data-type="info"
              />
            ))}

          {/* Bookmarks */}
          {Object.values(bookmarks).map((b, index) => (
            <SReaction
              key={index}
              className="far fa-bookmark fs-4"
              left={getPercentage(b.videoTs)}
              color="#68F795"
              onClick={() => player?.seekTo(b.videoTs)}
              onMouseEnter={() => showBookmarkTooltip(true)}
              data-for="bookmarks-tooltip"
              data-tip={JSON.stringify(b)}
              data-type="success"
            />
          ))}

          {reactionTooltip && (
            <ReactTooltip
              id="reactions-tooltip"
              clickable={true}
              getContent={setReactionTooltipContent}
              delayHide={500}
            />
          )}
          <ReactTooltip id="questions-tooltip" clickable={true} type="info" delayHide={500} />
          {bookmarkTooltip && (
            <ReactTooltip
              id="bookmarks-tooltip"
              clickable={true}
              type="info"
              getContent={setBookmarksTooltipContent}
              delayHide={500}
            />
          )}
        </SFeedbackBar>
      )}
    </>
  );
};

export default FeedbackBar;
